import React from 'react';
import Icon from '@mdi/react';
import { mdiClose } from '@mdi/js';
import { Col, Modal, ModalBody, ModalFooter } from 'reactstrap';

import './DeleteHeader.scss'; // Assuming you have a separate CSS file for styles

function DeleteHeader({ isOpen, toggle, header, onConfirm }) {
  const handleDelete = () => {
    onConfirm();
    toggle();
  };
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="xs">
      <div className="modal-header-custom px-4 pt-3 pb-2 d-flex justify-content-between align-items-center">
        <h5 className="modal-title mb-0">Delete Header</h5>
        <Icon
          path={mdiClose}
          size={1}
          color="#000000"
          onClick={toggle}
          className="cursor-pointer"
        />
      </div>
      <ModalBody>
        <div>
          <p>Are you sure you want to delete - {header}?</p>
        </div>
      </ModalBody>
      <ModalFooter>
        <Col>
          <button
            type="button"
            onClick={toggle}
            className="custom-light-btn w-100"
          >
            Cancel
          </button>
        </Col>
        <Col>
          <button
            type="button"
            className="custom-danger-btn w-100"
            onClick={handleDelete}
          >
            Confirm
          </button>
        </Col>
      </ModalFooter>
    </Modal>
  );
}

export default DeleteHeader;
